exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-label[data-v-125176c0] {\n  font-size: 15px;\n}\n.select-all-options[data-v-125176c0] {\n  margin-bottom: 10px;\n  border-bottom: 1px solid #3d4852;\n}\n.custom-border[data-v-125176c0] {\n  border: 1px solid !important;\n}\n.step-counter-text[data-v-125176c0] {\n  font-size: 15px;\n  font-weight: 600;\n}\n", ""]);

// exports
